export default __webpack_public_path__ + "static/media/fench.a55e9187.svg";